const initialState = {
  activeExperiments: {},
};

export default function reducer(state = initialState, action = {}) {
  const { type } = action;
  switch (type) {
    default:
      return state;
  }
}

export const selectIsExperimentInitialized = experimentId => state => {
  const activeExperiments = state?.abTest?.activeExperiments;
  return Boolean(activeExperiments && activeExperiments[experimentId] !== undefined);
};

export const selectExperimentVariant = experimentId => state => {
  return state?.abTest?.activeExperiments?.[experimentId] ?? null;
};